if(document.querySelector(".hulk__wishlist-wrap")){
      document.body.addEventListener("click",(e) => {
        const btn = document.querySelectorAll("[data-addmywishlistprotocart],[data-hulkmoveallitmes] a,.popup-product-offer [data-addprotocart],[data-hulkmywiswhlistmoveallitmes] a");
        btn.forEach((addBtn,index) =>{
          if(e.target == addBtn){
        setTimeout(async function(){
          var newCart = new CartDrawer();

          const c = addBtn.closest('.wishlist-card');
          if (!c || !dataLayer) return;

          const p = await fetch(`${Shopify.routes.root}products/${c.dataset.handle}.js`).then(r => r.json());
          const v = p.variants.find(v => v.id == c.dataset.varid);
          if (!v) return;

          const s = p.options?.find(o => o.name.toLowerCase() === 'size')?.position;
          const price = v.price / 100;

          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: 'INR', value: price, items: [{
                item_id: `${v.id}`, item_name: p.title, affiliation: 'Online Store', index,
                item_brand: p.vendor || 'Birkenstock', item_category: p.type || '',
                item_variant: v.title || '', item_size: s ? v.options[s - 1] : '', price, quantity: 1
              }]
            }
          });

          newCart.refresh();
        },1000);
            setTimeout(function(){
            document.querySelector('#cart-drawer-toggle').click();
        },1500);
              
          }
        });
      });
    }
// document.querySelector('.wishlist-btn').addEventListener('touchend', function(event) {
//     event.preventDefault();
//     // Add your custom logic here
// });
